import React, { useState } from "react";
import { SFQueryBuilder } from "@sf-core";
import { Logger } from "@base-provider";

const QueryBuilder = () => {
  const [query, setQuery] = useState(null);
  const fields = [
    {
      name: "firstName",
      label: "First Name",
      dataType: "select",
      multiple: true,
      source: [{ value: "lala" }, { value: "lalala" }],
    },
    { name: "lastName", label: "Last Name", dataType: "text" },
    { name: "phone", label: "Phone", dataType: "number" },
  ];
  return (
    <SFQueryBuilder
      fields={fields}
      query={query}
      onChange={(q) => {
        Logger.of("App.mock.queryBuilder").info({ query: q });
        setQuery(q);
      }}
    />
  );
};

export default QueryBuilder;
